module.exports = __webpack_public_path__ + "img/account.b22ae9e7.png";